import React from 'react';
import loadable from '@loadable/component';
import APIS from '../constant/EndPoint';
import useGetHook from '../customHooks/useGetHook';
import useTenantControlGetHook from '../customHooks/useTenantControlGetHook';
const WelcomeComponent = loadable(() => import('../components/Welcome'));
const Welcome = () => {
  const { data: profile, isLoading: isprofiledataLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const { data: websiteData, isLoading } = useTenantControlGetHook({
    url: APIS.WEBSITE,
    queryKey: ['get-website'],
    params: {},
  });
  return <WelcomeComponent profile={profile} websiteData={websiteData} />;
};

export default Welcome;
